import { AUDIT_ACTIONS_VOCABULARIES } from './audit-actions.js';
/** Slice s of the catalog (D577): the vocabularies the SERVER builds and writes to audit/event records (ADR-0105 §6). */
export const SLICE_S = [...AUDIT_ACTIONS_VOCABULARIES];
//# sourceMappingURL=slice-s.js.map